import { NgModule } from '@angular/core';
import {
  LibTbDynamicFormModule,
  LibTbButtonModule,
  LibTbCalendarModule,
  LibTbInputTextModule,
  LibTbCheckboxModule,
  LibTbProgressSpinnerModule,
  LibTbAccordionModule,
  LibTbUploadingFileModule,
  LibTbFileUploadFieldModule,
  LibTbModalNotificationModule,
  LibTbModalModule,
  LibTbDropdownModule,
  LibTbRadioButtonModule,
  LibTbSwitchModule,
  LibTbAlertModule,
  LibTbEmptyStateModule,
  LibTbCardModule,
  LibTbAnswerStateModule,
  LibTbBannerModule,
  LibTbTagModule,
  LibTbSearchModule,
  LibTbAvatarModule,
  LibTbChipModule,
  LibTbIndicatorGalleryModule,
} from 'tech-block-lib';

@NgModule({
  exports: [
    LibTbDynamicFormModule,
    LibTbButtonModule,
    LibTbCalendarModule,
    LibTbInputTextModule,
    LibTbCheckboxModule,
    LibTbProgressSpinnerModule,
    LibTbAccordionModule,
    LibTbUploadingFileModule,
    LibTbFileUploadFieldModule,
    LibTbModalNotificationModule,
    LibTbModalModule,
    LibTbDropdownModule,
    LibTbRadioButtonModule,
    LibTbSwitchModule,
    LibTbAlertModule,
    LibTbEmptyStateModule,
    LibTbCardModule,
    LibTbAnswerStateModule,
    LibTbBannerModule,
    LibTbTagModule,
    LibTbSearchModule,
    LibTbAvatarModule,
    LibTbChipModule,
    LibTbIndicatorGalleryModule,
  ],
})
export class TechBlocksModule {}
